import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 1,
  class: "text-blue-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("div", { class: "card-title" }, [
        _createElementVNode("h6", null, "Balances sum 💰"),
        _createElementVNode("div", { class: "subtitle" }, "Excluding balances less than zero")
      ])
    ], -1)),
    (_ctx.balancesSumLoading)
      ? (_openBlock(), _createBlock(_component_PrimeVueSkeleton, {
          key: 0,
          class: "mt-1",
          height: "16px"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$n(_ctx.balancesSum, 'payout')), 1))
  ]))
}